import React, { Component } from 'react';
import Chart from 'react-apexcharts';

class OrderBarrelChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: {
        chart: {
          id: 'basic-bar'
        },
        xaxis: {
          categories: props.xaxis
        }
      },
      series: [
        {
          name: 'Naročenih kosov embalaže',
          data: props.ordered
        },
        {
          name: 'Pobranih kosov embalaže',
          data: props.collected
        },
        {
          name: 'Vrnjenih kosov embalaže',
          data: props.returned
        }
      ]
    };
  }

  render() {
    return (
      <div className="app">
        <div className="row">
          <div className="mixed-chart">
            <Chart options={this.state.options} series={this.state.series} type="bar" width={1080} height={400} />
          </div>
        </div>
      </div>
    );
  }
}

export default OrderBarrelChart;
